module.exports = __webpack_public_path__ + "static/flags/TS-f7168026331d4cebb617f44950fce261.gif";